/**
 * Created by jv on 19/07/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");

let UserServices = {};

((UserServices) =>
{
  UserServices.logout = function()
  {
    return request.get({
        url: "/logout",
        cache: false
    });
  };

  UserServices.usernameExists = function(username)
  {
    return request.post({
      // url: "/access/authenticate/password",
      url: utils.getServiceUrl(`/users/validate-username/${encodeURIComponent(username)}`),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    });
  };

  UserServices.authenticateUser = function(username, password)
  {
    // AuthenticateUserServlet functions as a proxy for /access/authenticate/password so we can force logout when a new authentication is requested
    return request.post({
        // url: "/access/authenticate/password",
        // url: "/authenticate-user",
        url: "/authenticate-user",
        cache: false,
        dataType: request.DATA_TYPES.TEXT,
        contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
        data: {
            username: utils.isDefined(username) ? username : null,
            password: utils.isDefined(password) ? password : null
        }
    });
  };

  UserServices.requestPasswordReset = function(username)
  {
    return request.post({
      url:  utils.getServiceUrl("/users/reset-password"),
      cache: false,
      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
      data: {
        username: username
      }
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  UserServices.changePassword = function(data)
  {
    return request.post({
      url:  utils.getServiceUrl("/users/change-password"),
      cache: false,
      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
      data: {
        username: data.username,
        "password-old": data.passwordOld,
        "password-new": data.passwordNew,
        ticket: data.ticket
      }
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  UserServices.getUser = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/users/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
    })
      .then((data) =>
      {
        let user = null;

        if(utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data))
        {
          user = data.data;
        }

        return user;
      });
  };

  UserServices.registerUser = function(userObj)
  {
    return request.post({
      url:  utils.getServiceUrl("/users/register"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
          firstname: userObj.firstname,
          username: userObj.username,
          password: userObj.password,
          email: userObj.email,
          country: userObj.country,
          locale: userObj.locale
      }
    }).then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  UserServices.editProfile = function(userKey, userObj)
  {
    return request.put({
      url:  utils.getServiceUrl(`/users/${userKey}/edit-profile`),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
      data: {
        firstname: userObj.firstName,
        "current-password": userObj.currentPassword,
        "new-password": userObj.newPassword
      }
    }).then((data) =>
      {
          let rtrnData = null;

          if (utils.isNotNull(data) && data.result === "success" && data.data)
          {
              rtrnData = data.data;
          }

          return rtrnData;
      });
  };
  
    UserServices.updateLocale = function(userKey, locale)
    {
        return request.put({
            url: utils.getServiceUrl(`/users/${userKey}/update-locale`),
            cache: false,
            dataType: request.DATA_TYPES.JSON,
            contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
            data: {
                locale,
            }
        }).then((data) =>
        {
            let rtrnData = null;

            if (utils.isNotNull(data) && data.result === "success" && data.data)
            {
                rtrnData = data.data;
            }

            return rtrnData;
        });
    }
})(UserServices);

module.exports = UserServices;



// WEBPACK FOOTER //
// ./app/js/services/user-services.js